import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toggleSwitch,
        popUpMessageChange,
        editCards, 
        editFeaturesGroup, 
        editFigures, 
        selectedCardsGroupsChange} from '../../actions/index.js';

import { _ } from '../../functions/translator.js';

import { Button } from '@material-ui/core';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import SendIcon from '@material-ui/icons/Send';

import { postData } from '../../functions/postData.js';
import { reloadCardsGroupsFeatures } from '../../functions/map/reloadCardsGroups.js';
import { showMessage } from '../../functions/popUpMessage.js';
import { ToggleActions } from '../../constants/constants.js';

class ChangeCategory extends React.Component{

    constructor(props) {
        super(props)
        this.state = {
            cardCategoryId: 0,
        }
    }

    handleOnClick = async () => {
        const message =  _('Cambiando Categoría') + '...';
        showMessage(this.props, message, { loading: true });
        let urlPost = {
            project_id: window.project_id,
            card_category_id: this.state.cardCategoryId, 
            cards_group_ids: this.props.selectedCardsGroups,
        }
        let cardsGroupIds = [...this.props.selectedCardsGroups];
        this.handleClose();
        let response = await postData('/web-api/change-cards-groups-card-category', urlPost);
        this.handleResponse(response, cardsGroupIds);
    }

    handleClose = () => {
        this.props.toggleSwitch(ToggleActions.CHANGE_CATEGORY_COMPONENT, false);
        this.props.selectedCardsGroupsChange([]);
    }

    handleResponse = (response, cardsGroupIds) => {
        const success = response.status === 'success';
        const message = success ? '!' + _('Categoría cambiada exitosamente') + '!' : _('Ocurrió un error, no se pudo cambiar la categoría');
        showMessage(this.props, message);
        if (success) {
            reloadCardsGroupsFeatures(this.props, cardsGroupIds);
        }
    }

    handleCategoryChange = (event) => {
        this.setState({ cardCategoryId: event.target.value });
    };


    render(){
        const options = []
        for (const [key, categoryData] of Object.entries(this.props.projectData.card_categories)) {
            const stageId = categoryData.attributes.stage_id;
            const stageName = this.props.projectData.stages[stageId]?.attributes.name;
            const categoryFullName = `${stageName} - ${categoryData.attributes.name}`;
            options.push(
                <MenuItem value={categoryData.id} key={key}>
                    {categoryFullName}
                    <div 
                    className='color-square right-layout' 
                    style={{ backgroundColor: categoryData.attributes.color }}>
                    </div>
                </MenuItem>
            )
            
        }
        return (
            <div>
                { this.props.changeCategory ? (
                    <div>
                        <div className='sensitive-background' onClick={this.handleClose}></div>
                        <div className="add-progress-card-layout card-color">
                            <h4 className='text-center'>{ _('Cambiar Categoría') }</h4>
                            <div className='my-4'>
                                <Select
                                value={this.state.cardCategoryId}
                                onChange={this.handleCategoryChange}>
                                {options}
                                </Select>
                            </div>
                            <div className='d-flex justify-content-center'>
                                <Button variant="contained" onClick={this.handleOnClick} className='success-button'>
                                    <SendIcon/>
                                    <span style={{ paddingLeft: 10 }}>{ _('Cambiar')}</span>
                                </Button>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div></div>
                )}
            </div>
        )
    }
}

function mapStateToProps( state ){
    return {
        projectData         : state.projectData,
        changeCategory      : state.switches.changeCategory,
        selectedCardsGroups : state.selectedCardsGroups,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        toggleSwitch : toggleSwitch,
        selectedCardsGroupsChange : selectedCardsGroupsChange,
        popUpMessageChange : popUpMessageChange,
        editFeaturesGroup : editFeaturesGroup,
        editCards : editCards,
        editFigures : editFigures
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ChangeCategory)